import { render } from "./ScoreInfoWinRate.vue?vue&type=template&id=1616f685"
import script from "./ScoreInfoWinRate.vue?vue&type=script&lang=js"
export * from "./ScoreInfoWinRate.vue?vue&type=script&lang=js"

import "./ScoreInfoWinRate.vue?vue&type=style&index=0&id=1616f685&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__